var cov_16j96890h2 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Card/styles/index.ts",
      hash = "adc636cbf32f53aba94ec2286dc1d4d20b3cc68c",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Card/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 25
        },
        end: {
          line: 5,
          column: 53
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var cardLess = {};
import genaration from '../../utils/classname';
export var cardClass = (cov_16j96890h2.s[0]++, genaration(cardLess, 'card'));